<app-cosy-form-control></app-cosy-form-control>

<form novalidate #f="ngForm">
  <div *ngIf="interfaceElements?.length">

    <div class="form-group" ngModelGroup="cosyFormGroup">

      <!-- Name is created -->

      <div *ngIf="ieObj['6bf4ce01-8a10-490e-8fba-31808a1c1360'].Attributes.Visible"
      class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['6bf4ce01-8a10-490e-8fba-31808a1c1360'].PreLabel.DisplayName}}
          </label>
        </div>
        <div class="col-xs-7">
          <input
          class="form-control form-control-sm"
          type="text"
          name="{{ieObj['6bf4ce01-8a10-490e-8fba-31808a1c1360'].InterfaceElementID}}"
          [(ngModel)] = "ieObj['6bf4ce01-8a10-490e-8fba-31808a1c1360'].Values.Value"
          #Name ="ngModel"
          required
          >
          <div class="alert alert-danger col-form-label-sm" role="alert" *ngIf="Name.errors?.required && Name.touched" >
              {{ieObj['6bf4ce01-8a10-490e-8fba-31808a1c1360'].PreLabel.DisplayName}} is required
          </div>
        </div>
      </div>

      <!-- Email is created -->

      <div *ngIf="ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].Attributes.Visible" class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].PreLabel.DisplayName}}
          </label>
        </div>
        <div class="col-xs-7">
          <input
          class="form-control form-control-sm"
          type="text"
          name="{{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].InterfaceElementID}}"
          [(ngModel)] = "ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].Values.Value"
          #Email ="ngModel"
          required
          mask = "{{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].Attributes.Mask.Pattern}}"
          >
          <div class="alert alert-danger col-form-label-sm" role="alert"  *ngIf="Email.errors?.required && Email.touched">
            {{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].PreLabel.DisplayName}} is required
          </div>
          <div class="alert alert-danger col-form-label-sm" role="alert"  *ngIf="Email.errors?.mask && Email.touched" >
            {{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].PreLabel.DisplayName}} Pattern is not Valid <i>(e.g: {{ieObj['c1f2d0b1-3405-41fe-8823-4c2316172db3'].Attributes.Mask.Value}})</i>
          </div>
       </div>
      </div>

      <!-- Sex is created -->

      <div *ngIf="ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Attributes.Visible"
      class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].PreLabel.DisplayName}}</label>
        </div>
        <div class="col-xs-7">
          <select class="form-control form-control-sm" name="{{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].InterfaceElementID}}" [(ngModel)]="ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Values.Value">
            <option [value] = "ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[0].ID">
              {{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[0].DisplayName}}
            </option>
            <option [value] = "ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[1].ID">
              {{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[1].DisplayName}}
            </option>
             <option [value] = "ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[2].ID">
              {{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[2].DisplayName}}
            </option>
            <option [value] = "ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[3].ID">
              {{ieObj['ca932d51-97ce-4298-8316-f39ad1efeae1'].Source.ItemSet.Items[3].DisplayName}}
            </option>
          </select>
        </div>
      </div>

      <!-- BirthYear is created-->

      <div *ngIf="ieObj['9628efae-49ef-456b-94af-621a0548f326'].Attributes.Visible"
      class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].PreLabel.DisplayName}}
          </label>

        </div>
        <div class="col-xs-7">
          <input
            class="form-control form-control-sm"
            type="text"
            name="{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].InterfaceElementID}}"
            [(ngModel)] = "ieObj['9628efae-49ef-456b-94af-621a0548f326'].Values.Value"
            #Birthyear ="ngModel"
            required
            minimum = "{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].Attributes.Min}}"
            maximum = "{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].Attributes.Max}}"
            datatype = "{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].DataTypeID}}"
            >
            <div class="alert alert-danger col-form-label-sm" role="alert"   *ngIf="Birthyear.errors?.required && Birthyear.touched" >
              {{ieObj['9628efae-49ef-456b-94af-621a0548f326'].PreLabel.DisplayName}} is required
            </div>
            <div  class="alert alert-danger col-form-label-sm" role="alert"  *ngIf="Birthyear.errors?.minimum && Birthyear.touched">
              {{ieObj['9628efae-49ef-456b-94af-621a0548f326'].PreLabel.DisplayName}}  should be greater than <i>{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].Attributes.Min}}</i>
            </div>
            <div class="alert alert-danger col-form-label-sm" role="alert"   *ngIf="Birthyear.errors?.maximum && Birthyear.touched" >
              {{ieObj['9628efae-49ef-456b-94af-621a0548f326'].PreLabel.DisplayName}}  should be less than <i>{{ieObj['9628efae-49ef-456b-94af-621a0548f326'].Attributes.Max}}</i>
            </div>
            <div class="alert alert-danger col-form-label-sm" role="alert"   *ngIf="Birthyear.errors?.numericDT && Birthyear.touched" >
              {{ieObj['9628efae-49ef-456b-94af-621a0548f326'].PreLabel.DisplayName}}  is not Numeric <i>( Should be within: [0-9])</i>
            </div>
          </div>
      </div>

      <!-- Date is created -->

      <div *ngIf="ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].Attributes.Visible"
      class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].PreLabel.DisplayName}}</label>
        </div>
        <div class="col-xs-7">
          <input
            class="form-control form-control-sm"
            type="text"
            name="{{ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].InterfaceElementID}}"
            [(ngModel)] = "ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].Values.Value"
            #Date ="ngModel"
            required
            datatype = "{{ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].DataTypeID}}">
            <div  class="alert alert-danger col-form-label-sm" role="alert" *ngIf="Date.errors?.required && Date.touched" >
              {{ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].PreLabel.DisplayName}} is required
            </div>
            <div  class="alert alert-danger col-form-label-sm" role="alert" *ngIf="Date.errors?.dateDT && Date.touched" >
              {{ieObj['37b0a153-876a-4b60-98ee-02623791bd23'].PreLabel.DisplayName}} is not a Valid <i>(Should be: mm/dd/yyyy)</i>
            </div>
          </div>
      </div>

      <!-- IsMember is created -->

      <div *ngIf="ieObj['97b4a47e-68f8-4387-ab80-b6a3b597f4fc'].Attributes.Visible"
       class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['97b4a47e-68f8-4387-ab80-b6a3b597f4fc'].PreLabel.DisplayName}}</label>
        </div>
        <div class="col-xs-7">
          <input type="checkbox" name="{{ieObj['97b4a47e-68f8-4387-ab80-b6a3b597f4fc'].InterfaceElementID}}"  [(ngModel)]="ieObj['97b4a47e-68f8-4387-ab80-b6a3b597f4fc'].Values.Value">
        </div>
      </div>

      <!-- SpeakLanguage is created-->

      <div *ngIf="ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Attributes.Visible"
       class="form-group row">
        <div class="col-xs-5">
          <label class="col-form-label-sm">{{ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].PreLabel.DisplayName}}</label>
        </div>
        <div class="col-xs-7">
          <select class="form-control form-control-sm" name="{{ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].InterfaceElementID}}" [(ngModel)]="ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Values.Value">
            <option [value] = "ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[0].ID">
              {{ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[0].DisplayName}}
            </option>
            <option [value] = "ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[1].ID">
              {{ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[1].DisplayName}}
            </option>
             <option [value] = "ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[2].ID">
              {{ieObj['ea8e6098-2f46-43a8-b66f-3ac0c71096b3'].Source.ItemSet.Items[2].DisplayName}}
            </option>
          </select>
         </div>
      </div>
    </div>
  </div>

</form>